import { combineReducers } from 'redux';
import { isLoadingReducer } from 'store/reducerUtils';
import { createDealType } from './actions';

const isCreationInProgress = isLoadingReducer(createDealType);

export const dealType = combineReducers({
    isCreationInProgress,
});
